// extracted by mini-css-extract-plugin
export default {"root":"Container_root__e33Mm","container":"Container_container__4stks"};